import { useParams } from 'react-router-dom';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';

interface Props {
  groupId: string;
  periodId: string;
  cartId: string;
}

const useGroupQuoteUrlParams = (): Props => {
  const { groupId } = useParams<{ groupId: string }>();

  const query = useQueryParams();
  const cartId = query.get('cartId') || '';
  const periodId = query.get('periodId') || '';

  return { groupId, periodId, cartId };
};

export default useGroupQuoteUrlParams;
